import Vue from 'vue';
import Vuex from 'vuex';

import urlsAPI from '../../config/urlsAPI';
import handlerError from '../../utils/errors';
import { axiosInstance } from '../../main';

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    settings: [],
  },
  mutations: {
    updateSettings(state, settings) {
      state.settings = settings;
    },
  },
  actions: {
    getSettings({ commit }) {
      axiosInstance.get(urlsAPI.settingsURL)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('updateSettings', response.data);
          }
        })
        .catch(handlerError);
    },

    updateSettings({ commit, state }) {
      axiosInstance.put(urlsAPI.settingsURL, state.settings)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('updateSettings', response.data);
          }
        })
        .catch(handlerError);
    },
  },
};
